export default __webpack_public_path__ + "static/tag-do-2-light-7f7b5c7de65c4402b467692e83e3996b2a7ee1b92be6c4ec8e8f3b0573695ef5.png";